import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayGridDate } from './utils';
import type { AccountRouteProps, AuthorizedRequestProps, ODataQueryParams } from './types';

export const MAXIMUM_ADGROUP_COUNT_UNDER_CAMPAIGN = '500';

// TODO: Implement fetchAdGroupData function and props
export interface IFetchAdGroupsUrlProps extends AccountRouteProps {
  campaignId?: string;
  params?: ODataQueryParams;
}

const AdGroupOdataConfig = {
  $expand: 'Campaign($select=BidStrategyName,CampaignCashback,CampaignSettings,CampaignSubType,CampaignType,ExperimentId,Id,Languages,Name),Labels,RSAAdCustomizerAttributes',
  $top: MAXIMUM_ADGROUP_COUNT_UNDER_CAMPAIGN,
  $skip: '0',
  $count: 'true',
  $orderby: 'DeliveryStatus asc',
  $nullifynotapplybidamounts: 'true',
  $select: 'AdGroupType,CommissionRate,CpmBid,CpvBid,DeliveryStatus,DeliveryStatusDetails,DisplayBiddingStrategyType,EndDate,EntityStatus,FinalUrlSuffix,Id,IsBidLandscapeAvailable,Language,Medium,Name,PercentCpcBid,PerformanceMetrics/AbsoluteTopImpressionRate,PerformanceMetrics/ConversionsCredit,PerformanceMetrics/TopImpressionRate,PerformanceMetrics/ViewThroughConversionsCredit,QualityScore/OverallQualityScore,SearchBid,StartDate,TrackingUrlTemplate,UrlCustomParameters',
};

export interface IFetchAdGroupsDataProps extends IFetchAdGroupsUrlProps, AuthorizedRequestProps {}

export function getFetchAdGroupUrl({
  customerId,
  accountId,
  campaignId,
  params = AdGroupOdataConfig,
}: IFetchAdGroupsUrlProps) {
  const queryString = new URLSearchParams(params);

  if (!campaignId) {
    return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/AdGroups/Default.GridData?${queryString}`;
  }
  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/AdGroups/Default.GridData?${queryString}`;
}

export function fetchAdGroupsData({
  accountId,
  customerId,
  campaignId,
  ccToken,
}: IFetchAdGroupsDataProps) {
  const url = getFetchAdGroupUrl({ customerId, accountId, campaignId });

  const postDataParams = {
    gridDataParameters: {
      DateRange: {
        StartDate: formatTodayGridDate(),
        EndDate: formatTodayGridDate(),
      },
      CurrentCustomerId: customerId,
    },
  };

  return axios.post(
    url,
    {
      ...postDataParams,
    },
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
        'x-ms-applicationname': 'bingadsweb',
        'x-ms-clientapplication': 'bingadsweb',
      },

    } as AxiosRequestConfig
  );
}
